import React from "react";
import { ArrowUpRight } from "lucide-react";

const WEBSITE_DEVELOPMENT_URL = "https://mynavodayans.in/contact?service=custom-website-development";

export const FooterDeveloperCredit = () => (
    <div
        data-testid="footer-developer-section"
        className="mt-6 flex min-w-0 flex-col gap-5 border-t border-white/10 pt-6 text-xs leading-relaxed lg:flex-row lg:items-center lg:justify-between"
    >
        <p data-testid="footer-developer-credit" className="min-w-0 text-white/70 lg:max-w-md">
            Website Designed &amp; Developed by{" "}
            <a
                data-testid="footer-developer-link"
                href={WEBSITE_DEVELOPMENT_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Mynavodayans Online Services Pvt. Ltd. — website development enquiries (opens in a new tab)"
                className="rounded-sm font-medium text-white/85 underline decoration-white/30 underline-offset-4 transition-colors duration-200 hover:text-brand-gold hover:decoration-brand-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold"
            >
                Mynavodayans Online Services Pvt. Ltd.
            </a>
        </p>
        <div className="flex min-w-0 flex-col items-start gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4">
            <p data-testid="footer-website-cta-text" className="text-white/80">
                Need a Professional Website for Your Business?
            </p>
            <a
                data-testid="footer-website-cta-link"
                href={WEBSITE_DEVELOPMENT_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get Your Website — contact Mynavodayans Online Services Pvt. Ltd. (opens in a new tab)"
                className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-full border border-white/20 px-4 py-2 font-semibold text-brand-gold transition-colors duration-200 hover:border-brand-gold/60 hover:bg-white/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold"
            >
                Get Your Website
                <ArrowUpRight aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
            </a>
        </div>
    </div>
);